import React, { Component } from "react";
import { connect } from "react-redux";
import interceptors from "../Services/interceptor";
import { setLoaderOn, setLoaderOff } from "../Actions/authActions";
import ContentLoader from "./widgets/ContentLoader";

class InterceptorsComponent extends Component {
  componentWillMount() {
    interceptors.setupInterceptors(this.props.history, this.toggleLoader);
  }

  render() {
    return <div>{this.props.loaderOn ? <ContentLoader /> : null}</div>;
  }

  toggleLoader = (isTurnOn) => {
    if (isTurnOn) this.props.setLoaderOn();
    else this.props.setLoaderOff();
  };
}

const mapStateToProps = (state) => {
  return {
    loaderOn: state.authReducer.loaderOn
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLoaderOn: () => dispatch(setLoaderOn()),
    setLoaderOff: () => dispatch(setLoaderOff())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InterceptorsComponent);
